import { Expose } from "@nts/std/serialization";
import { FindOptions } from './find-options';
import type { FindValuesOptionsInterface } from '@nts/std/interfaces';

export class FindValuesOptions extends FindOptions implements FindValuesOptionsInterface {

    @Expose()
    outputProperties: string[];

    constructor(findOptions?: FindOptions, outputProperties: string[] = []) {
        super(findOptions);
        this.outputProperties = outputProperties;
    }
}
